module.exports = __webpack_public_path__ + "img/warning-balance.b12d84e1.png";